// extracted by mini-css-extract-plugin
export var body = "_kb-0";
export var sectionHeader = "_kb-4";
export var shortcutColumns = "_kb-2";
export var shortcutList = "_kb-1";
export var shortcutSection = "_kb-3";